import api from './api';

const resource = 'Company/';

export const list = async (query = '') => {
  return await api.get(resource + 'List' + query);
};

export const lookup = async () => {
  return await api.get(resource + 'Lookup');
};

export const getById = async (id) => {
  return await api.get(resource + 'Get?id=' + id);
};

export const upsert = async (body, config) => {
  return await api.post(resource + 'Upsert', body, config);
};

export const deleteById = async (id) => {
  return await api.delete(resource + 'Delete?id=' + id);
};

export const deleteLogoById = async (companyid) => {
  return await api.delete(resource + 'DeleteLogo?companyId=' + companyid);
};

export const signAsCompanyById = async (id) => {
  return await api.get(resource + 'LoginAsCompany?id=' + id);
};

const companyApi = {
  list,
  lookup,
  getById,
  upsert,
  deleteById,
  signAsCompanyById,
  deleteLogoById,
};

export default companyApi;
